import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { config, FacialRecognitionService } from '@fgb/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { FacialRecognitionModalComponent } from '../facial-recognition-modal/facial-recognition-modal.component';
import { Router } from '@angular/router';

enum RewardWidth {
  Destop = 302,
  Tablet = 194,
  Mobile = 165,
}

@Component({
  selector: 'fgb-facial-recognition-uploader-info',
  templateUrl: './facial-recognition-uploader-info.component.html',
  styleUrl: './facial-recognition-uploader-info.component.scss',
})
export class FacialRecognitionUploaderInfoComponent implements OnInit, OnDestroy {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData: FormControl = new FormControl();
  @Input() isUploadInfo: boolean = false;
  @Input() isfacialRouteLinkDisabled: boolean = false;
  @Input() facialRecognitionLink: string = '/facial-recognition';
  @Input() facialRecognitionQRLink: string = '/facialsinglepage';
  @Output() isUploadInfoChange = new EventEmitter<boolean>();
  facialRecognitionHeading: string = 'facial.recognition.heading';
  facialRecognitionSubheading: string = 'facial.recognition.subheading';
  destroy$ = new Subject<void>();
  facialWidth: number | string;
  config: any = config;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.setFacialWidth(event?.target.screen.width);
  }

  barcode: string;

  constructor(
    private facialRecognitionService: FacialRecognitionService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setFacialWidth(window.screen.width);
  }

  setFacialWidth(screenSize: number) {
    if (screenSize >= 992) this.facialWidth = RewardWidth.Destop;
    if (screenSize < 992) this.facialWidth = RewardWidth.Mobile;
  }

  goToFacialRecognition(goToStep: number) {
    const formValues = {
      uploadedImageForm: this.uploadedImage,
      formData: this.formData,
      isUploadInfo: this.isUploadInfo,
      goToStep: goToStep,
    };
    if (this.facialWidth === RewardWidth.Mobile) {
      if (!this.isfacialRouteLinkDisabled) {
        this.router.navigate([this.facialRecognitionLink]);
      }
      this.activeModal.close(formValues);
    } else if (this.facialWidth === RewardWidth.Destop) {
      this.modalService.dismissAll();
      const modalRef = this.modalService.open(FacialRecognitionModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'facial-recognition-modal',
        centered: true,
      });

      const modalComponent = modalRef.componentInstance as FacialRecognitionModalComponent;
      modalComponent.uploadedImage = this.uploadedImage;
      modalComponent.formData = this.formData;
      modalComponent.isUploadInfo = this.isUploadInfo;
      modalComponent.goToStep = goToStep;
      modalComponent.isUploadInfoChange.pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.isUploadInfo = x;
      });
    }
  }

  takePhoto() {
    this.goToFacialRecognition(1);
  }

  uploadedImageChange() {
    this.isUploadInfo = true;
    this.isUploadInfoChange.emit(this.isUploadInfo);
    this.goToFacialRecognition(2);
  }

  getImageDataByLink() {
    firstValueFrom(this.facialRecognitionService.generateFacialImageByLink()).then((response) => {
      this.barcode = this.config.portalUrl + this.facialRecognitionQRLink + '?key=' + response.AccessKey;

      if (this.barcode) {
        this.facialRecognitionHeading = 'facial.recognition.barcode.heading';
        this.facialRecognitionSubheading = 'facial.recognition.barcode.subheading';
      }
    });
  }

  close() {
    this.activeModal.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
